import { forOwn, isNil, isString } from 'lodash'

import {
  UploadFileParameter,
  uploadFileApi
} from '@eastcoal/api/nexus/oss/uploadFile'

import { StrictOmit } from '../types/utilities'

import { ApiConfig } from './fetcher/interface'

export type WrapUploadFileApiOptions = StrictOmit<
  UploadFileParameter,
  'file' | 'url'
> & {
  file?: Blob | string
}

export const wrapUploadFileApi = async (
  { file, metadata, ...restOptions }: WrapUploadFileApiOptions,
  config?: ApiConfig
) => {
  const formData = new FormData()
  const paramName = isString(file) ? 'url' : 'file'
  if (file) formData.append(paramName, file)
  if (metadata) formData.append('metadata', JSON.stringify(metadata))

  forOwn(restOptions, (value, key) => {
    if (!isNil(value)) {
      formData.append(key, value.toString())
    }
  })

  return uploadFileApi(formData as any, {
    silence: true,
    ...config
  })
}
